<template>
  <div
    class="recebivel-card"
    :class="[statusClass, variant === 'drawer' ? 'recebivel-card--drawer' : '']"
  >
    <div class="recebivel-card__bar" :class="barClass || ''" />

    <template v-if="variant === 'drawer'">
      <div class="recebivel-card__drawer-layout">
        <div class="recebivel-card__status-icon" :class="drawerStatusIconClass" aria-hidden="true">
          <svg v-if="drawerStatusKey === 'paid'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <svg v-else-if="drawerStatusKey === 'overdue'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <svg v-else-if="drawerStatusKey === 'due-soon'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <svg v-else fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <div class="recebivel-card__drawer-content">
      <div class="recebivel-card__drawer-head">
        <div class="recebivel-card__drawer-main">
          <p class="recebivel-card__valor">{{ formatMoneyAmount(item.valor || 0, locale) }}</p>
          <p v-if="item.descricao" class="recebivel-card__desc">{{ item.descricao }}</p>
        </div>
        <span class="recebivel-card__badge" :class="badgeClass">{{ statusLabel }}</span>
        <ClienteIconBtn
          v-if="showDelete"
          variant="delete"
          class="shrink-0"
          @click="$emit('delete', item)"
        />
      </div>
      <ul class="recebivel-card__meta">
        <li class="recebivel-card__meta-item">
          <svg class="recebivel-card__meta-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          <span>{{ t('kanban.taskDetail.sections.finance.dueLabel', { date: formatDateOnly(item.dataVencimento) }) }}</span>
        </li>
        <li v-if="item.pago && item.dataPagamento" class="recebivel-card__meta-item recebivel-card__meta-item--paid">
          <svg class="recebivel-card__meta-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span>{{ t('kanban.taskDetail.sections.finance.paidOn', { date: formatDateOnly(item.dataPagamento) }) }}</span>
        </li>
      </ul>
      <div class="recebivel-card__actions recebivel-card__actions--drawer">
        <button
          type="button"
          class="recebivel-card__btn recebivel-card__btn--drawer-action"
          :class="item.pago ? 'recebivel-card__btn--undo-drawer' : 'recebivel-card__btn--pay-drawer'"
          @click="$emit('toggle-pago', item)"
        >
          <svg v-if="!item.pago" class="recebivel-card__btn-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <svg v-else class="recebivel-card__btn-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h10a8 8 0 018 8v2M3 10l4-4m-4 4l4 4" />
          </svg>
          <span>{{ item.pago ? t('workspaceClienteModal.financeiro.undoShort') : t('workspaceClienteModal.financeiro.markPaidShort') }}</span>
        </button>
        <button
          type="button"
          class="recebivel-card__btn recebivel-card__btn--drawer-action recebivel-card__btn--ghost-drawer"
          @click="$emit('edit', item)"
        >
          <svg class="recebivel-card__btn-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
          </svg>
          <span>{{ t('kanban.taskDetail.sections.finance.edit') }}</span>
        </button>
      </div>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="flex items-start justify-between gap-3">
        <div class="flex items-center gap-3 min-w-0">
          <div class="recebivel-card__icon">
            <img src="@/assets/money-icon.png" alt="" class="w-6 h-6 object-contain" />
          </div>
          <div class="min-w-0">
            <p class="recebivel-card__valor">{{ formatMoneyAmount(item.valor || 0, locale) }}</p>
            <p v-if="item.descricao" class="recebivel-card__desc">{{ item.descricao }}</p>
            <p class="recebivel-card__due">
              {{ t('kanban.taskDetail.sections.finance.dueLabel', { date: formatDateOnly(item.dataVencimento) }) }}
            </p>
            <p v-if="item.pago && item.dataPagamento" class="recebivel-card__paid-on text-xs mt-1">
              {{ t('kanban.taskDetail.sections.finance.paidOn', { date: formatDateOnly(item.dataPagamento) }) }}
            </p>
          </div>
        </div>
        <span class="recebivel-card__badge" :class="badgeClass">{{ statusLabel }}</span>
        <ClienteIconBtn
          v-if="showDelete"
          variant="delete"
          class="shrink-0"
          @click="$emit('delete', item)"
        />
      </div>
      <div class="recebivel-card__actions">
        <button type="button" class="recebivel-card__btn recebivel-card__btn--ghost" @click="$emit('edit', item)">
          {{ t('kanban.taskDetail.sections.finance.edit') }}
        </button>
        <button
          type="button"
          class="recebivel-card__btn"
          :class="item.pago ? 'recebivel-card__btn--undo' : 'recebivel-card__btn--pay'"
          @click="$emit('toggle-pago', item)"
        >
          {{ item.pago ? t('kanban.taskDetail.sections.finance.undoPayment') : t('kanban.taskDetail.sections.finance.markPaid') }}
        </button>
      </div>
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { formatMoneyAmount } from '@/utils/format'
import ClienteIconBtn from './ClienteIconBtn.vue'

const props = defineProps({
  item: { type: Object, required: true },
  locale: { type: String, default: 'pt-BR' },
  statusClass: { type: String, default: '' },
  barClass: { type: String, default: '' },
  badgeClass: { type: String, default: '' },
  statusLabel: { type: String, default: '' },
  formatDateOnly: { type: Function, required: true },
  /** Layout otimizado para o drawer lateral estreito */
  variant: { type: String, default: 'default' },
  showDelete: { type: Boolean, default: false }
})

defineEmits(['edit', 'toggle-pago', 'delete'])

const { t } = useI18n()

const drawerStatusKey = computed(() => {
  const cls = props.statusClass || ''
  if (cls.includes('paid')) return 'paid'
  if (cls.includes('overdue')) return 'overdue'
  if (cls.includes('due-soon')) return 'due-soon'
  return 'open'
})

const drawerStatusIconClass = computed(() => `recebivel-card__status-icon--${drawerStatusKey.value}`)
</script>

<style scoped>
.recebivel-card {
  position: relative;
  padding: 1rem 1.125rem;
  border-radius: 4px;
  margin-bottom: 0.625rem;
  overflow: hidden;
  border: 1px solid var(--border-primary, #e2e8f0);
}

.recebivel-card--drawer {
  padding: 0;
  margin-bottom: 0;
  border-radius: 4px;
  overflow: visible;
  height: auto;
  flex-shrink: 0;
}

.recebivel-card--drawer .recebivel-card__bar {
  display: none;
}

.recebivel-card__drawer-layout {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.875rem 1rem;
  height: auto;
  min-height: 0;
}

.recebivel-card__status-icon {
  flex-shrink: 0;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.recebivel-card__status-icon svg {
  width: 1.25rem;
  height: 1.25rem;
}

.recebivel-card__drawer-content {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
}

.recebivel-card__drawer-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
}

.recebivel-card__drawer-main {
  min-width: 0;
  flex: 1;
}

.recebivel-card--drawer .recebivel-card__valor {
  font-size: 1.25rem;
  line-height: 1.2;
  letter-spacing: -0.02em;
}

.recebivel-card__meta {
  list-style: none;
  margin: 0.75rem 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}

.recebivel-card__meta-item {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  font-size: 0.75rem;
  line-height: 1.35;
  color: var(--text-secondary, #64748b);
}

.recebivel-card__meta-item--paid {
  color: var(--success, #047857);
}

.recebivel-card__meta-icon {
  width: 1rem;
  height: 1rem;
  flex-shrink: 0;
  margin-top: 0.1rem;
  opacity: 0.85;
}

.recebivel-card__actions--drawer {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 0.375rem;
  margin-top: 0.5rem;
  padding-top: 0.5rem;
  border-top: 1px solid var(--border-primary, #e2e8f0);
}

.recebivel-card__btn--drawer-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  min-height: 1.625rem;
  padding: 0.25rem 0.5rem;
  font-size: 0.6875rem;
  font-weight: 600;
  line-height: 1.2;
  border-radius: 4px;
  border: 1px solid transparent;
  background: transparent;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.recebivel-card__btn-icon {
  width: 0.875rem;
  height: 0.875rem;
  flex-shrink: 0;
}
.recebivel-card__bar {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 3px;
}
.recebivel-card__bar--paid { background: linear-gradient(90deg, #10b981, #34d399); }
.recebivel-card__bar--due { background: linear-gradient(90deg, #f59e0b, #fbbf24); }
.recebivel-card__bar--overdue { background: linear-gradient(90deg, #ef4444, #f87171); }
.recebivel-card__icon {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 4px;
  background: linear-gradient(135deg, #10b981, #3b82f6);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.recebivel-card__valor {
  font-size: 1.125rem;
  font-weight: 700;
  margin: 0;
}
.recebivel-card__desc {
  font-size: 0.8125rem;
  font-weight: 500;
  color: var(--text-primary);
  margin: 0.25rem 0 0;
  line-height: 1.35;
}

.recebivel-card__due {
  font-size: 0.75rem;
  margin: 0.125rem 0 0;
  color: var(--text-secondary);
}
.recebivel-card__badge {
  font-size: 0.6875rem;
  font-weight: 700;
  padding: 0.25rem 0.625rem;
  border-radius: 4px;
  border: 1px solid;
  white-space: nowrap;
}
.recebivel-card__actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px dashed var(--border-primary);
}
.recebivel-card__btn {
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.375rem 0.75rem;
  border-radius: 4px;
  transition: background 0.15s;
}
.recebivel-card__btn--pay {
  background: var(--success);
  color: #fff;
}
.recebivel-card__btn--pay:hover { filter: brightness(1.08); }
.recebivel-card__btn--undo {
  background: var(--warning);
  color: #fff;
}
</style>
